



















































import {Component, Vue} from 'vue-property-decorator';
import {getImageURL, getScore, stopSurvey} from '@/app/api/survey.api';
import {ScoreResponse} from '@/app/models/score-response';
import QrcodeVue from 'qrcode.vue';
import Header from '@/app/components/Header.vue';
import Footer from '@/app/components/Footer.vue';

@Component({
    components: {Footer, Header, QrcodeVue},
})
export default class AdminContainer extends Vue {
    public isLoading = false;
    public score: ScoreResponse | null = null;

    public getImageURL(imageId: string) {
        if (this.score != null) {
            return getImageURL(this.$route.params.surveyCode, imageId);
        }
        return null;
    }

    public async mounted() {
        this.isLoading = true;
        try {
            await this.stopSurveyIfNotClosed();
            this.score = await getScore(this.$route.params.surveyCode);
        } catch (error) {
            if (
                'response' in error &&
                'status' in error.response &&
                error.response.status === 404
            ) {
                this.$router.push('/404');
                return;
            }
            throw error;
        } finally {
            this.isLoading = false;
        }
    }

    public async stopSurveyIfNotClosed() {
        try {
            await stopSurvey(this.$route.params.surveyCode);
        } catch (error) {
            if (
                'response' in error &&
                'status' in error.response &&
                error.response.status === 400
            ) {
                return;
            }
            throw error;
        }
    }

    public back() {
        this.$router.push('/');
    }
}
